// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import VeeValidate, { Validator } from 'vee-validate'
import {ConfigValidation} from './validation/config'
import {CustomMessages} from './validation/custom-messages'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import {
  RomajiCheck,
  EmailCheck,
  NumberCheckLength,
  MoneyMin,
  BankAccountOnlyNumber,
  BankAccountOnlyName,
  JustNumberCheckLength
} from '@/validation/custom-rules'
import VueEvents from 'vue-events'
import VTooltip from 'v-tooltip'
import VueCurrencyInput from 'vue-currency-input'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

import ToggleButton from 'vue-js-toggle-button'
Vue.config.productionTip = false
Vue.use(VeeValidate, ConfigValidation)
Vue.use(Loading, {
  color: '#2a609a'
})
Vue.use(VueEvents)
Validator.extend('romaji', RomajiCheck)
Validator.extend('email', EmailCheck)
Validator.extend('numberLength', NumberCheckLength)
Validator.extend('justNumberLength', JustNumberCheckLength)
Validator.extend('moneyMin', MoneyMin)
Validator.extend('bankAccountOnlyNumber', BankAccountOnlyNumber)
Validator.extend('bankAccountOnlyName', BankAccountOnlyName)
Validator.localize(CustomMessages)
Vue.use(VTooltip, {
  popover: {defaultPlacement: 'top'}
})
Vue.use(VueCurrencyInput)
Vue.use(VueGoodTablePlugin)
Vue.use(ToggleButton)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js